import React, { useContext, useEffect } from 'react';
import { matchPath, useHistory } from 'react-router';
import { Route, RouteProps } from 'react-router-dom';
import { LayoutContext } from 'contexts';
import type { Location } from 'history';

type PageRouteProps = RouteProps & {
  title: string;
};

const PageRoute: React.FC<PageRouteProps> = ({
  title,
  path,
  strict,
  exact,
  ...props
}) => {
  const { setAppTitle } = useContext(LayoutContext);

  const history = useHistory();
  useEffect(() => {
    function update(location: Location) {
      if (matchPath(location.pathname, { path, strict, exact })) {
        setAppTitle(title);
      }
    }
    update(history.location);
    return history.listen(update);
  }, [path, strict, exact, history, title, setAppTitle]);

  return <Route path={path} exact={exact} strict={strict} {...props} />;
};

export default PageRoute;
